export default {
  namespaced: true,

  getters: {
    getCTypeLabels: (_, __, ___, rootGetters) => cTypes =>
      cTypes ? cTypes.map(({ fk_Tipo_Anagrafico }) => rootGetters['apis/getObjLabel'](fk_Tipo_Anagrafico, 'counterpartTypes')).join(', ') : '',

    cTypesByRole: (_, __, rootState, rootGetters) => rootGetters['apis/forSelect']('counterpartTypes')
      .filter(({ value }) => rootState.auth.user.roles.all.includes('ctypes') ? true : rootState.auth.user.roles.ctypes.includes(value)),
  },
}
